import { useEffect, useState } from "react";
import { deleteGroup, getBookedAuditionees, setRecallVerdict } from "../../../../CastingBotFirebase";
import SectionLoader from "../../../../_shoru_shared_library/loaders/SectionLoader";
import SubTabNoData from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabNoData";
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { v4 as uuidv4 } from 'uuid';

function RecallGroupsTab(props)
{
  function filterForRecalls(x) {return x.recalled}

  const userData = props.userData;
  const castingData = props.extraData;
  const setCastingData = props.setExtraData;
  const [slots, setSlots] = useState(castingData.slots.filter(filterForRecalls));
  const [recallees, setRecallees] = useState(null);
  
  // A flag that is set to false when uploading/downloading information from the server
  const [editingEnabled, setEditingEnabled] = useState(true);

  // Get auditionee data
  useEffect(() => {
    getBookedAuditionees(slots, userData.active_organisation_id, setRecallees);
    // eslint-disable-next-line
  }, []);

  if(recallees === null) return <SectionLoader />

  const recallGroups = _getRecallGroups(slots, castingData.roles);

  // If no groups are added, display message
  if(recallGroups.length === 0)
  {
    return (
      <SubTabNoData 
        icon={faPlusSquare} 
        title='No Recall Groups' 
        description="Create recall groups to view them here"
      />
    )
  }

  return (
    <SubTabParent passData={props}>
      <GroupsDisplay 
        organisationId={userData.active_organisation_id}
        projectId={castingData.uid}
        recallees={recallees}
        slots={slots} 
        setSlots={setSlots} 
        groups={recallGroups}
        editingEnabled={editingEnabled}
        setEditingEnabled={setEditingEnabled}
        setCastingData={setCastingData}
      />
    </SubTabParent>
  )

}

export default RecallGroupsTab;





function GroupsDisplay(props)
{
  const organisationId = props.organisationId;
  const projectId = props.projectId;
  const allRecallees = props.recallees;
  const slots = props.slots;
  const setSlots = props.setSlots;
  const groups = props.groups;
  const editingEnabled = props.editingEnabled;
  const setEditingEnabled = props.setEditingEnabled;
  const setCastingData = props.setCastingData;

  groups.sort((a,b) => {return a.character_key > b.character_key? 1 : -1})
  var previousCharacterKey = null;

  let groupsDisplay = groups.map((group, index) => {

    var characterKeyChanged = false;
    var characterKeyString = '';
    var groupMembers = [];

    // If the date has changed, make a note of this
    if(group.character_key !== previousCharacterKey) {
      characterKeyChanged = true;
      characterKeyString = group.recallees.map((recallee, index) => {
        return recallee.role + (index === group.recallees.length - 1? '' : ' / ');
      })
      previousCharacterKey = group.character_key;
    }

    group.recallees.forEach((recallee, index) => {
      // Add the recallee details to the group array
      allRecallees.forEach((r) => {
        if(r.uid === recallee.recallee_id) {
          group.recallees[index].name = r.name;
          group.recallees[index].email = r.email;
          group.recallees[index].phone = r.phone;
        };
      })
    })

    console.log(group.recallees);

    let memberDisplay = group.recallees.map((member) => {
      const verdictColour = _getVerdictColour(member.verdict);
      return (
        <div key={uuidv4()}>
          <div className='console-recall-slot-details' style={{color: verdictColour}}>
            {member.name}
            <i>{member.email}</i>
            <i style={{color: (verdictColour + '77')}}>{member.phone}</i>
          </div>

          <div className='console-recall-slot-role'>
            {member.role}
          </div>

          <div className={'console-recall-slot-booking-options' + (props.narrow? '-narrow' : '')}>
            <select defaultValue={member.verdict} onChange={async(e) => { 
              setEditingEnabled(false);
              await setRecallVerdict(e.target.value, member.recallee_id, group.group_id, organisationId, projectId, setSlots, setCastingData);
              setEditingEnabled(true);
            }} disabled={!editingEnabled} title='Verdict of audition'>
              <option value='undetermined'>-</option>
              <option value='excellent'>Excellent</option>
              <option value='good'>Good</option>
              <option value='ok'>Ok</option>
              <option value='poor'>Poor</option>
            </select>
          </div>
        </div>
      )
    })

    return (
      <div key={uuidv4()}>
        {characterKeyChanged? (
          <h2 style={{marginTop: '20px'}}>{characterKeyString}</h2>
        ) : null}
        <div key={index} className={'console-recall-slot' + (props.narrow? '-narrow' : '')}>
          <div className='console-recall-slot-members-display'>
            {memberDisplay}
          </div>
          <div className='console-recall-slot-bin'>
            <FontAwesomeIcon icon={faTrash} title='Remove group' style={{...{color: '#e74c3c'},...{cursor: 'pointer'}}} onClick={async() => {
              setEditingEnabled(false);
              await deleteGroup(group.group_id, organisationId, projectId, setSlots, setCastingData);
              setEditingEnabled(true);
            }} />
          </div>
        </div>
      </div>
    )

  })

  return (
    <div className='console-audition-slots-container'>
      {groupsDisplay}
    </div>
  )
}



const _getVerdictColour = (verdict) => {
  if      (verdict === 'undetermined')    return '#cccccc'; // Light grey
  else if (verdict === 'poor')            return '#e74c3c'; // Red
  else if (verdict === 'ok')              return '#e67e22'; // Orange
  else if (verdict === 'good')            return '#f1c40f'; // Yellow
  else                                    return '#2ecc71'; // Green
}


/**
 * Recall groups structure:
 * 
 * [
 *  {
 *    group_id          - unique identifier for this group. Can be used to edit recall information
 *    character_key     - a string unique to that combination of characters
 *    recallees: [
 *      {
 *        recallee_id   - the auditionee ID of the recalled individual
 *        role          - the name of the role they are recalled for in this group
 *        verdict       - the verdict of their performance as the given role in this group
 *      }
 *    ]
 *  }
 * ]
 */
const _getRecallGroups = (slots, roles) => {

  var groupsDict = {}

  slots.forEach((slot) => {

    slot.notes.recall_verdicts.forEach((recall) => {

      var roleName = null;
      roles.forEach((role) => {
        if(recall.role_id === role.id.toString()) roleName = role.name;
      })

      const groupId = recall.group_id;
      if(groupsDict[groupId] === undefined)
      {
        groupsDict[groupId] = {
          group_id: groupId,
          character_key: [recall.role_id],
          recallees: [{
            recallee_id: slot.auditionee_id,
            role: roleName,
            verdict: recall.verdict
          }]
        }
      }
      else
      {
        groupsDict[groupId] = {
          group_id: groupId,
          character_key: [...groupsDict[groupId].character_key, recall.role_id],
          recallees: [...groupsDict[groupId].recallees, {
            recallee_id: slot.auditionee_id,
            role: roleName,
            verdict: recall.verdict
          }]
        }
      }

    })

  })

  // We convert the entire dictionary into an array, to make it easier to iterate over, then
  // The character_key value is used for identifying groupings for the same character(s), regardless of their order in the system
  // Here, character_keys must be sorted and flattened from a list to a single string.
  var groupsArray = Object.values(groupsDict);
  groupsArray.forEach((group, index) => {
    const characterKeyString = group.character_key.sort().toString();
    groupsArray[index].character_key = characterKeyString
  })

  return groupsArray;

}